import { z } from 'zod';
import { useAuth } from '#global/context/auth/useAuth.tsx';
import { useZodParams } from '#hooks/useZodParams.ts';
import { NotFound } from '#screens/404/NotFound.tsx';
import { EditAdminProvider } from './admin/EditAdminProvider.tsx';
import { EditEndpointProvider } from './endpoint/EditEndpointProvider.tsx';

export function EditIdentityProviderPage() {
  const { providerId } = useZodParams({ providerId: z.string() });
  const { user } = useAuth();

  // This shouldn't happen, unless we screw up react-router somehow
  if (!providerId) return <NotFound />;

  const providerType = providerId.split('-')[0];

  switch (providerType) {
    case 'endpointoidc':
      return <EditEndpointProvider endpointOidcProviderId={providerId} />;
    case 'oidcprovider':
      // Be sure we have a user, only let totp admins access editing.
      if (!user) return null;
      if (user.type === 'oidcUser') return <NotFound />;
      return <EditAdminProvider oidcProviderId={providerId} />;
    case undefined:
    default:
      return <NotFound />;
  }
}
